var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconViewHistory = function SvgIconViewHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18.279
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.744 0a9.25 9.25 0 0 0-8.711 6.043l-.955-1.7a.574.574 0 1 0-1 .562l1.571 2.8a.57.57 0 0 0 .759.232l2.794-1.428a.571.571 0 1 0-.518-1.017l-1.517.777a8.009 8.009 0 1 1-.313 4.713.571.571 0 1 0-1.107.268 9.237 9.237 0 1 0 9-11.246Zm.054 3.99a.57.57 0 0 0-.509.58v4.57a.57.57 0 0 0 .214.446l2.856 2.285a.572.572 0 0 0 .714-.893l-2.642-2.115V4.57a.57.57 0 0 0-.634-.58Z",
    "data-name": "Path 5930"
  })));
};
export default SvgIconViewHistory;